import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from '@common/services/ui/modal.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.scss'],
})
export class ErrorScreenComponent implements AfterViewInit, OnInit, OnDestroy {
  private errorDialogId = 'error-dialog';
  public errorTitle = 'Error Title';
  public errorText = 'Something went wrong';
  private subscriptions: Subscription[] = [];

  constructor(private authService: AuthService, private modalService: ModalService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        if (params['title'] != null) {
          this.errorTitle = params['title'];
        }
        if (params['description'] != null) {
          this.errorText = params['description'];
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.openErrorDialog();
    });
  }

  public async closeDialog(): Promise<void> {
    this.modalService.close(this.errorDialogId);
    await this.onCloseDialog();
  }
  public async onCloseDialog(): Promise<void> {
    await this.authService.signOut();
  }

  private openErrorDialog(): void {
    this.modalService.open(this.errorDialogId);
  }
}
